import { Card, CourseSearch } from "@/components";
import { useState } from "react";
import { useRouter } from "next/router";

import Styles from "./CourseGrid.module.css";

/**
 * @typedef {import("@prismicio/client").Content.CourseGridSlice} CourseGridSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<CourseGridSlice>} CourseGridProps
 * @param {CourseGridProps}
 */

const valueExists = (arr, nestedKey, key, value) => {
	return arr.some((obj) => obj[nestedKey] && obj[nestedKey][key] === value);
};

const CourseGrid = ({ slice: { primary }, courses, industries }) => {
	const { query, ...router } = useRouter();
	const [active, setActive] = useState(query?.industry || "all");
	const [filteredCourses, setFilteredCourses] = useState(courses);

	const handleClick = (industry) => {
		const newActive = industry;
		router.push(
			{
				pathname: "/training/courses",
				query: { industry: newActive },
			},
			undefined,
			{ shallow: true, scroll: false }
		);
		setActive(newActive);
	};

	return (
		<section className={Styles.wrapper}>
			<div
				className={Styles.industryContainer}
				data-contain='true'>
				<button
					className={Styles.industryBtn}
					onClick={() => handleClick("all")}
					data-active={active === "all"}>
					All Courses
				</button>
				{/* Sort industries by priority - lower values first then higher or undefined */}
				{industries
					.sort(
						(a, b) =>
							(a?.data?.priority || Infinity) - (b?.data?.priority || Infinity)
					)
					.map((industry, index) => (
						<button
							className={Styles.industryBtn}
							key={index}
							onClick={() => handleClick(industry?.uid)}
							data-active={active === industry?.uid}>
							{industry?.data?.industry_name}
						</button>
					))}
			</div>
			<div
				className={Styles.searchContainer}
				data-contain='true'>
				<CourseSearch
					courses={courses}
					setFilteredCourses={setFilteredCourses}
				/>
			</div>
			<div
				className={Styles.cardContainer}
				data-contain='true'>
				{/* Sort array to put priority courses first -> if the industry is active return those courses otherwise return all */}
				{filteredCourses
					.sort(
						(a, b) =>
							(b?.data?.priority === true) - (a?.data?.priority === true)
					)
					.map((course, index) => {
						const industries = course?.data?.industries;
						//Check if industry is active
						const activeIndustry = valueExists(
							industries,
							"industry",
							"uid",
							active
						);
						if (activeIndustry) {
							return (
								<Card
									link={{
										link_type: "Document",
										url: course?.url,
									}}
									image={course?.data?.featured_image}
									title={course?.data?.card_title}
									description={course?.data?.card_description}
									key={index}
								/>
							);
						}
						if (active == "all") {
							return (
								<Card
									link={{ link_type: "Document", url: course?.url }}
									image={course?.data?.featured_image}
									title={course?.data?.card_title}
									description={course?.data?.card_description}
									key={index}
								/>
							);
						}
					})}
			</div>
		</section>
	);
};

export default CourseGrid;
